import { StarFilledIcon } from "@radix-ui/react-icons";
import { Check, Highlighter, MoreHorizontal, Pin } from "lucide-react";
import React from "react";
import { cn } from "ui/lib/utils";

/**
 * One glyph per meaning, at every width. A hint that points at a control
 * draws the same glyph the control shows, so the two can't drift.
 * Lucide glyphs carry a 24px height attribute: size them with `size-*`.
 */

/** "More" on any row, card, bar or tab. */
export const MoreIcon = MoreHorizontal;

/** Coach priority, and nothing else. */
export const PriorityStar = StarFilledIcon;

/** A highlighted message. */
export const HighlightIcon = Highlighter;

/** Pinning: a message to the room, a team to the top of the switcher. */
export const PinIcon = Pin;

/** The current choice in a list or the on state of a toggle: always volt. */
export const SelectedCheck = ({ className }: { className?: string }) => (
  <Check
    aria-hidden="true"
    className={cn("size-5 shrink-0 text-primary", className)}
  />
);
